import type { DateTime } from "luxon";

export const formatArrivedAt = (date: DateTime): string => {
  const { locale } = useI18n();

  return date.toFormat('HH:mm, dd MMMM', { locale: locale.value });
};
